/*! msm-smile-offset v1.1 (16 Oct 2026) - keeps the Smile.io "Rewards" launcher clear of
   anything pinned to the bottom of the screen on mobile/tablet (<990px):
   hp26 bottom nav, PDP sticky add-to-basket, cart sticky checkout bar, cookie banner.
   Measures the real height of whatever is showing (includes safe-area padding), sets
   --msm-smile-bottom, and toggles html.msm-smile-lift. When nothing is showing the class
   is removed and Smile's own position (bottom:16px) is untouched. Desktop: no-op.
   Covers both Smile launchers: lite (#smile-ui-lite-launcher-frame-container) and the
   full UI launcher Smile swaps in after first tap / for signed-in customers
   (.smile-launcher-frame-container). Rollback: see /workspace/rewards-button-fix-2026-10-16/ROLLBACK.md */
(function(){
  if(!window.matchMedia) return;
  var mq=matchMedia('(max-width:989.98px)');
  var root=document.documentElement, GAP=12, last=null, raf=0;
  var BARS='.hp26-bnav,sticky-atc-panel,.sticky-atc-panel,[data-msmc-sticky]';
  var st=document.createElement('style');
  st.id='msm-smile-offset-css';
  st.textContent='@media (max-width:989.98px){'+
    'html.msm-smile-lift #smile-ui-lite-launcher-frame-container,'+
    'html.msm-smile-lift .smile-launcher-frame-container,'+
    'html.msm-smile-lift [id^="smile-ui"] [class*="launcher-frame-container"]'+
    '{bottom:var(--msm-smile-bottom,16px)!important;transition:bottom .2s ease!important}}';
  (document.head||root).appendChild(st);

  function cover(){
    var vh=window.innerHeight||root.clientHeight, max=0, els=document.querySelectorAll(BARS);
    for(var i=0;i<els.length;i++){
      var el=els[i], cs=getComputedStyle(el);
      if(cs.position!=='fixed'&&cs.position!=='sticky') continue;
      if(cs.display==='none'||cs.visibility==='hidden'||parseFloat(cs.opacity)===0) continue;
      var r=el.getBoundingClientRect();
      if(r.width<1||r.height<1||r.top>=vh-1||r.bottom<vh-48) continue; /* showing and docked at (or floating just above) the bottom */
      var c=vh-r.top;
      if(c>max) max=c;
    }
    if(root.classList.contains('hp26-csm-open')){
      var h=parseFloat(getComputedStyle(root).getPropertyValue('--hp26-csm-h'))||0;
      if(h>max) max=h;
    }
    return Math.ceil(max);
  }
  function update(){
    raf=0;
    var c=mq.matches?cover():0, v=c>0?(c+GAP)+'px':'';
    if(v===last) return; last=v;
    if(v){ root.style.setProperty('--msm-smile-bottom',v); root.classList.add('msm-smile-lift'); }
    else { root.classList.remove('msm-smile-lift'); root.style.removeProperty('--msm-smile-bottom'); }
  }
  function req(){ if(!raf) raf=requestAnimationFrame(update); }
  window.addEventListener('scroll',req,{passive:true});
  window.addEventListener('resize',req,{passive:true});
  if(window.visualViewport) visualViewport.addEventListener('resize',req,{passive:true});
  document.addEventListener('transitionend',req,true);
  document.addEventListener('click',function(){ setTimeout(req,80); setTimeout(req,400); },true);
  if(mq.addEventListener) mq.addEventListener('change',req);
  if(window.MutationObserver) new MutationObserver(req).observe(root,{attributes:true,subtree:true,attributeFilter:['class','hidden','aria-hidden','open']});
  setInterval(req,1000);
  req();
})();
